<template>
  <fragment>
    <default-header :h2="$t('passwordReset.title')"></default-header>
    <back-btn></back-btn>
    <div class="innerContent noBottomPadding noSpaceBetween pl-1 pr-1">
      <img class="login-tester" src="@/assets/ebt965p.png" alt="Exide EBT-965P" />
      <div>
        <form @submit.prevent="submit" v-if="!responseSuccess">
          <div class="form-group small-label mb-1">
            <input
              type="password"
              class="form-control mb-3"
              id="password"
              :placeholder="$t('setNewPassword.password')"
              v-validate="'required|min:8'"
              v-model="password"
              :data-vv-as="$t('general.passwordMustMatch')"
              name="password"
              ref="passwordRef"
            />
            <input
              type="password"
              class="form-control mb-4"
              id="password-confirm"
              :placeholder="$t('setNewPassword.confirmPassword')"
              v-model="passwordConfirm"
              v-validate="'required|confirmed:passwordRef'"
              :data-vv-as="$t('setNewPassword.passwordMustMatch')"
              name="password-confirm"
            />
            <span
              v-if="errors.first('password-confirm')"
              class="vv-error text-center d-block mt-2 mb-4"
            >{{ $t('setNewPassword.passwordMustMatch') }}</span>
            <span
              v-if="errors.first('password')"
              class="vv-error text-center d-block mt-2 mb-4"
            >{{ $t('registerPassword.characters') }}</span>
            <span
              v-if="responseError"
              class="vv-error text-center d-block mt-2 mb-4"
            >{{ $t('setNewPassword.responseError') }}</span>
          </div>
          <button type="submit" class="btn btn-primary btn-block mt-2">{{$t('general.send')}}</button>
        </form>
        <div
          v-if="responseSuccess"
          class="alert alert-success"
        >{{ $t('setNewPassword.responseSuccess') }}</div>
        <router-link
          to="/login"
          class="pl-1 pr-1 btn btn-primary btn-block mt-2 mb-4"
        >{{$t('general.login')}}</router-link>
      </div>
    </div>
  </fragment>
</template>

<script>
  import DefaultHeader from '@/partials/DefaultHeader';
  import { HTTP } from '../http';
  import BackBtn from '../components/BackBtn';

  export default {
    name: 'SetNewPassword',
    components: {
      DefaultHeader,
      BackBtn
    },
    beforeMount() {
      this.token = this.$route.query.token;
      this.email = this.$route.query.email;
    },
    data() {
      return {
        email: null,
        message: null,
        sent: false,
        token: null,
        password:null,
        passwordConfirm: null,
        responseError: false,
        responseSuccess: false
      };
    },
    methods: {
      submit() {
        this.responseError = false;
        this.$validator.validate().then( res => {
          if(res && this.token) {
            HTTP.post('/api/set-new-password',{
              "password": this.password,
              "password_confirmation": this.passwordConfirm,
              "token": this.token,
              "email": this.email
            }).then(res => {
              this.responseSuccess = true;
            }).catch( err => {
              this.responseError = err.response.data.error;
            })
          }
        })
      }
    }
  };
</script>

<style>

</style>
